import React from 'react';
import DesignV6 from './DesignV6';
import './Portfolio.css';

const Portfolio = () => {

  return (
    <div className="portfolio-wrapper">
      <div className="design-container">
        <DesignV6 />
      </div>
    </div>
  );
};

export default Portfolio;
